import { useEffect, useState } from 'react';
import { withFormik, useFormikContext } from 'formik';
import { useStore } from 'store';
import { fetchGuestRange } from 'store/actions/catalogs';
import { Select, CheckBox } from 'components';
import { downloadFileFromUrl } from 'services/commons';
import contractPdfLoQuiero from 'assets/docs/CONTATO-PLAN-LO-QUIERO-v3.pdf';
import contractPdfVirtual from 'assets/docs/CONTRATO-PLAN-VIRTUAL-v3.pdf';
import { mapPropsToValues, validationSchema } from './config';
import './index.scss';

const Guests = ({ onSaveData, handleSubmit, valueComplete, toggleCheckbox, selectedInitial, showCheck }) => {
  
  const [contract, setContract] = useState(0);
  const [guestOptions, setGuestOptions] = useState([]);

  const [catalogs, dispatch] = useStore((state) => state.catalogs);
  const { guestRange = [] } = catalogs;

  // This is for the values will receive from the table flow parent
  const { values } = useFormikContext();

  useEffect(() => {
    const guests = guestRange;

    if (guests && guests.length) {
      const transformedGuests = guests.map((guest) => {
        // eslint-disable-next-line radix
        const symbol = parseInt(guest.id) === guests.length ? '+' : '';
        const label = `${guest.minimum} - ${guest.maximum}  ${symbol}`;
        return {
          ...guest,
          value: guest.id,
          label
        };
      });
      setGuestOptions(transformedGuests);
    }
  }, [guestRange]);

  useEffect(() => {
    dispatch(fetchGuestRange());
  }, []);

  useEffect(() => {
    onSaveData({
      guests: values.guestNumber,
      valid: values.guestNumber && values.termsAndConditionsHasAccepted
    },'guests');
  }, [values.guestNumber, values.termsAndConditionsHasAccepted]);

  useEffect(() => {
    if (valueComplete?.select_plan?.plan) {
      setContract(valueComplete.select_plan.plan);
    }
  }, [valueComplete]);

  const handleLabelClick = () => {
    const pdfFile = contract === 1 ? contractPdfLoQuiero : contractPdfVirtual;
    const pdfName = contract === 1
      ? 'CONTATO-PLAN-LO-QUIERO.pdf'
      : 'CONTRATO-PLAN-VIRTUAL.pdf';
    downloadFileFromUrl(pdfFile, pdfName);
  };

  const handleCheckboxChange = (event) => {
    const { target: { checked } } = event;
    toggleCheckbox(checked);
  }

  return (
      <section className="Guests">
        <form onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-md-7 offset-md-3 select-container">
              <Select
                  label="Número de invitados"
                  groupClassName="m-2"
                  name="guestNumber"
                  placeholder="No. de invitados"
                  options={guestOptions}
                  className="inputBorder"
              />
            </div>
          </div>
          <CheckBox
              label="Acepto términos y condiciones"
              showCheck={showCheck}
              name="termsAndConditionsHasAccepted"
              groupClassName="TermAndConditions"
              containerClassName="p-0"
              value
              labelClassName="TermAndConditions__Label"
              onChange={handleCheckboxChange}
              onLabelClick={handleLabelClick}
              selectedInitial={selectedInitial}
          />
        </form>
      </section>
  );
};

export default withFormik({
  mapPropsToValues,
  validationSchema,
  validateOnChange: true,
  validateOnBlur: true
})(Guests);
